const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'trips',
        showEditByMySelf: true,
    },

    methods: {
        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            const titleParts = []
            if(entityAttributes.tripStart)      titleParts.push(utils.moment(entityAttributes.tripStart).format('DD.MM.YYYY'));
            if(entityAttributes.title)          titleParts.push(entityAttributes.title);
            // if(entityAttributes.firstname)      titleParts.push(entityAttributes.firstname);
            // if(entityAttributes.lastname)       titleParts.push(entityAttributes.lastname);
            // if(entityAttributes.nickname)       titleParts.push(`à ${entityAttributes.nickname}`);
            tabOptions.title = titleParts.join(' ~ ')
            tabOptions.titleSuffix = ` [ ${entityID} ]`

            if(tabOptions.title.length > 50){
                tabOptions.title = `${tabOptions.title.substring(0, 50)}...`
            }

            // if(entityAttributes.type === 'internal'){
            //     tabOptions.icon = 'fi fi-employee-internal'
            // } else if (entityAttributes.type === 'external'){
            //     tabOptions.icon = 'fi fi-employee-external'
            // } else if (entityAttributes.type === 'occasional'){
            //     tabOptions.icon = 'fi fi-employee-occasional'
            // }

            return tabOptions
        },

        // export(){
        //     console.log('parents of props controller')
        //     this.parentComponents(undefined, parent => {
        //         console.log(parent)
        //     }, true)
        // }
    },
}